module.exports = __webpack_public_path__ + "static/media/icon_titan.94f7b5e1.svg";